export default __webpack_public_path__ + "static/media/sandero-large.6c2cc7ba.jpg";